import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useMobileOptimized } from "@/hooks/useMobileOptimized";
import { motion } from "framer-motion";

const FAQ_ITEMS = [
  {
    question: "What is Artifact and who is it for?",
    answer:
      "Artifact is an AI assistant platform for anyone who wants to work smarter, not harder. Whether you're a student, professional, creative, or business owner, Artifact helps with writing, research, planning, and creative projects all in one place.",
  },
  {
    question: "How do I get started with Artifact?",
    answer:
      "Getting started is simple! Sign up for a free account, and you'll have immediate access to multiple AI models. No technical setup required - just start chatting with AI assistants that can help with any task you have in mind.",
  },
  {
    question: "Can I use Artifact with my existing apps?",
    answer:
      "Yes! Artifact integrates with popular tools you already use, including email platforms, document editors, project management tools, and more. Our integrations make it easy to incorporate AI assistance into your existing workflow.",
  },
  {
    question: "What's included in the Pro plan?",
    answer:
      "The Pro plan gives you access to the best AI models, unlimited personal projects, enhanced research capabilities, early access to new features, and the ability to create custom AI assistants tailored to your specific needs. Plus priority support when you need help.",
  },
  {
    question: "Can I collaborate with others on Artifact?",
    answer:
      "Absolutely! You can share projects and workspaces with teammates, classmates, or collaborators. Work together on documents, brainstorm ideas, and share AI conversations seamlessly. It's perfect for team projects, group assignments, or collaborative creative work.",
  },
  {
    question: "Is my data secure with Artifact?",
    answer:
      "Your privacy and security are our top priorities. We use enterprise-grade security measures including encryption and secure data handling. Your conversations and projects remain private to you and only those you choose to share them with.",
  },
];

export function FAQSection() {
  const { shouldReduceMotion } = useMobileOptimized();

  return (
    <section className="py-16 bg-transparent">
      <motion.div
        className="max-w-2xl mx-auto px-4"
        initial={{ opacity: 0, y: shouldReduceMotion ? 10 : 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: shouldReduceMotion ? 0.4 : 0.6,
          ease: "easeOut",
        }}
        viewport={{ once: true }}
      >
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Frequently Asked
            <br />
            Questions
          </h2>
          <p className="text-muted-foreground text-sm">
            Everything you need to know about Artifact and how it can transform
            the way you work
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {FAQ_ITEMS.map((item, index) => (
            <AccordionItem
              key={`item-${index + 1}`}
              value={`item-${index + 1}`}
              className="border-0 bg-muted rounded-lg overflow-hidden"
            >
              <AccordionTrigger className="text-left font-medium py-4 px-5 text-foreground hover:no-underline data-[state=open]:no-underline [&[data-state=open]>svg]:rotate-180">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="px-5 pb-4 text-muted-foreground text-sm">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </section>
  );
}

export default FAQSection;
